import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const keyFeatures = [
  { icon: 'ri-flashlight-line', title: 'Üç Tıkla Kurtarma', desc: 'Herhangi bir DR testi veya gerçek afet için üç tıkla kurtarma imkânı; hızlı, eksiksiz kurtarma ilk seferinde doğru yapılır.' },
  { icon: 'ri-database-2-line', title: 'Verimli Veri Replikasyonu', desc: 'Global satır içi tekilleştirme ve ioClone anlık görüntüleri ile yalnızca benzersiz artımlı veri aktarılır; bant genişliği minimize edilir.' },
  { icon: 'ri-router-line', title: 'Gelişmiş Yazılım Tanımlı Ağ', desc: 'VergeFabric SDN entegrasyonu ile ağ yük devri otomatikleştirilir; DR sitelerinde özdeş pahalı donanım ihtiyacı ortadan kalkar.' },
  { icon: 'ri-layout-grid-line', title: 'VDC ile Basit DR', desc: 'VM\'ler, depolama, ağ ve uygulamaları tek öğeye kapsülleyin — sanal veri merkezleri DR\'ı dramatik biçimde basitleştirir.' },
];

const savingsPoints = [
  'Emtia donanımı veya mevcut altyapı ile çalışır',
  'Bare-metal servis sağlayıcılarla uyumludur',
  'Pahalı özdeş donanım bağımlılığını azaltır',
  'Tamamen yapılandırılabilir replikasyon sıklığı',
];

const faqList = [
  { q: 'Felaket kurtarma (DR) nedir?', a: 'Felaket kurtarma, doğal afet, siber saldırı veya donanım arızası gibi yıkıcı olaylardan sonra BT sistemlerini, verileri ve altyapıyı geri yükleme sürecidir. DR\'ın amacı kesinti süresini minimize etmek, veri bütünlüğünü sağlamak ve operasyonları hızlı şekilde yeniden başlatmaktır.' },
  { q: 'Başarılı bir DR stratejisinin kritik bileşenleri nelerdir?', a: 'İdeal DR stratejisi şunları içerir: kapsamlı yedekleme ve kurtarma sistemleri, replikasyon mekanizmaları, net RPO/RTO hedefleri, belgelenmiş prosedürler ve sık test imkânı. ioReplicate tüm bunları tek platformda sunar.' },
  { q: 'İş sürekliliği ile DR arasındaki fark nedir?', a: 'İş sürekliliği, organizasyonun temel fonksiyonların nasıl devam edeceğini planlamasıdır. DR ise yıkıcı olaydan sonra sistemleri ve verileri geri yüklemeye odaklanır. ioReplicate her ikisini de destekler.' },
  { q: 'RPO ve RTO arasındaki fark nedir?', a: 'RPO (Recovery Point Objective), kabul edilebilir maksimum veri kaybı süresini tanımlar. RTO (Recovery Time Objective) ise sistemi geri yüklemek için gerekli maksimum süreyi ifade eder. ioReplicate her ikisini de karşılar.' },
  { q: 'Sanallaştırmanın DR\'daki rolü nedir?', a: 'Sanallaştırma; donanımdan bağımsız iş yükü taşıma, hızlı ortam klonlama ve izole test imkânı ile DR süreçlerini köklü biçimde basitleştirir. VergeOS VDC\'leri bu konuda en kapsamlı çözümü sunar.' },
  { q: 'ioReplicate geleneksel DR çözümlerinin zorluklarını nasıl giderir?', a: 'ioReplicate, VDC kapsülleme ile karmaşık ağ-depolama entegrasyonunu ortadan kaldırır; Global Satır İçi Tekilleştirme ile bant genişliği kullanımını azaltır ve SDN otomasyonu ile özdeş pahalı DR donanımı gerektirmez.' },
];

const ioreplicateJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'ioReplicate',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'ioReplicate ile VM ve site düzeyinde çoğaltma. Düşük RPO/RTO felaket kurtarma, WAN optimize çoğaltma.',
  url: `${SITE_URL}/ioreplicate`,
};

const ioreplicateFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Felaket kurtarma (DR) nedir?', acceptedAnswer: { '@type': 'Answer', text: 'Felaket kurtarma, doğal afet, siber saldırı veya donanım arızası gibi yıkıcı olaylardan sonra BT sistemlerini, verileri ve altyapıyı geri yükleme sürecidir. DR\'ın amacı kesinti süresini minimize etmek ve operasyonları hızlı yeniden başlatmaktır.' } },
    { '@type': 'Question', name: 'Başarılı bir DR stratejisinin kritik bileşenleri nelerdir?', acceptedAnswer: { '@type': 'Answer', text: 'İdeal DR stratejisi şunları içerir: kapsamlı yedekleme ve kurtarma sistemleri, replikasyon mekanizmaları, net RPO/RTO hedefleri, belgelenmiş prosedürler ve sık test imkânı. ioReplicate tüm bunları tek platformda sunar.' } },
    { '@type': 'Question', name: 'RPO ve RTO arasındaki fark nedir?', acceptedAnswer: { '@type': 'Answer', text: 'RPO (Recovery Point Objective), kabul edilebilir maksimum veri kaybı süresini tanımlar. RTO (Recovery Time Objective) ise sistemi geri yüklemek için gerekli maksimum süreyi ifade eder.' } },
    { '@type': 'Question', name: 'ioReplicate geleneksel DR çözümlerinin zorluklarını nasıl giderir?', acceptedAnswer: { '@type': 'Answer', text: 'ioReplicate, VDC kapsülleme ile karmaşık ağ-depolama entegrasyonunu ortadan kaldırır; Global Satır İçi Tekilleştirme ile bant genişliği kullanımını azaltır ve SDN otomasyonu ile özdeş pahalı DR donanımı gerektirmez.' } },
    { '@type': 'Question', name: 'Sanallaştırmanın DR\'daki rolü nedir?', acceptedAnswer: { '@type': 'Answer', text: "Sanallaştırma; donanımdan bağımsız iş yükü taşıma, hızlı ortam klonlama ve izole test imkânı ile DR süreçlerini köklü biçimde basitleştirir. VergeOS VDC'leri bu konuda en kapsamlı çözümü sunar." } },
  ],
};

export default function IoReplicatePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="ioReplicate | VM ve Site Çoğaltma | VergeOS"
        description="ioReplicate ile sanal makine ve site çoğaltma. Felaket kurtarma için düşük RPO/RTO, WAN optimize replikasyon ve üç tıkla tam VDC kurtarması."
        keywords="ioReplicate, VM çoğaltma, site replikasyon, disaster recovery, felaket kurtarma, VergeOS, DR"
        canonicalPath="/ioreplicate"
        jsonLd={[ioreplicateJsonLd, ioreplicateFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">Özellikler</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">ioReplicate</span>
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Felaket Kurtarmayı Basitleştirin</p>
            <p className="text-gray-400 text-sm mb-8 max-w-2xl mx-auto">ioReplicate, herhangi bir DR testi veya ilan edilmiş afet için üç tıkla kurtarma sağlar. İlk seferinde doğru, hızlı ve eksiksiz kurtarma.</p>
          </div>
        </section>

        {/* VMware Alternative */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Üstün Felaket Kurtarma ile en iyi Alternatif</h2>
                <p className="text-gray-600 mb-4 leading-relaxed">Felaket kurtarma hiç bu kadar kolay olmamıştı — <strong className="text-[#1e293b]">ioReplicate herhangi bir DR testi veya ilan edilmiş afet için üç tıkla kurtarma</strong> sağlar. İster DR senaryosunu simüle edin ister gerçek olaya karşılık verin, ioReplicate hızlı ve eksiksiz kurtarma, doğru ilk seferinde sunarak güveni artırır.</p>
                <p className="text-gray-600 leading-relaxed">VergeIO, BT ekiplerini güvenle geri yüklemeye olanak tanır; kesinti süresini minimize eder ve iş sürekliliğini korur.</p>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/8bb8a780b3a357c0462243164cc0d700.jpg" alt="ioReplicate DR Mimarisi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Temel Özellikler</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {keyFeatures.map(f => (
                <div key={f.title} className="bg-white rounded-lg border border-gray-100 p-6 flex gap-4">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0"><i className={`${f.icon} text-xl`}></i></span>
                  <div>
                    <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{f.title}</h3>
                    <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Cost Savings */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=flexible%20cost%20effective%20disaster%20recovery%20infrastructure%20showing%20commodity%20hardware%20servers%20at%20DR%20site%20with%20VergeOS%20software%20defined%20networking%20and%20storage%20replication%2C%20professional%20data%20center%20visualization%20with%20orange%20accent%20colors%20dark%20background%20technical%20diagram&width=580&height=400&seq=ioreplicate_cost1&orientation=landscape" alt="ioReplicate Maliyet Tasarrufu" className="w-full h-full object-top" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Esnek, Ekonomik Altyapı</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">ioReplicate, DR sitelerinde özdeş pahalı donanım gerektiren geleneksel DR çözümlerinin aksine çok daha esnek bir yaklaşım sunar.</p>
                <ul className="space-y-3 mb-6">
                  {savingsPoints.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
                <div className="bg-[#e8600a]/10 border border-[#e8600a]/20 rounded-lg p-5">
                  <p className="text-sm text-[#7a2e00] font-medium">ioReplicate'in esnekliği, kuruluşların bütçelerini tehlikeye atmadan sağlam bir DR stratejisi uygulamasına olanak tanır.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">ioReplicate SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0"><i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i></span>
                  </button>
                  {openFaq === i && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
